import {
  Award,
  ImagePlus,
  LayoutDashboard,
  Settings2,
  Swords,
  Users,
} from "lucide-react";

export const PROFILE_NAV_ITEMS = [
  {
    to: "/profile",
    label: "Vue d'ensemble",
    shortLabel: "Hub",
    description: "Hub joueur",
    icon: LayoutDashboard,
    end: true,
  },
  {
    to: "/profile/badges",
    label: "Badges",
    shortLabel: "Badges",
    description: "Badges obtenus",
    icon: Award,
  },
  {
    to: "/profile/image-proposals",
    label: "Photothèque",
    shortLabel: "Images",
    description: "Soumettre et suivre",
    icon: ImagePlus,
  },
  {
    to: "/profile/battles",
    label: "Battles",
    shortLabel: "Battles",
    description: "Création et invitations",
    icon: Swords,
  },
  {
    to: "/profile/friends",
    label: "Amis",
    shortLabel: "Amis",
    description: "Amis, invitations, messages",
    icon: Users,
  },
  {
    to: "/profile/account",
    label: "Compte",
    shortLabel: "Compte",
    description: "Infos et avatars",
    icon: Settings2,
  },
];
